function n(n,t){const o=n.find((n=>!!n[0]));return o?o[1]():t()}export{n as returnOrFallthrough};
